module.exports = __webpack_public_path__ + "img/ไก่งวง.a8a5e436.jpg";